import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React from 'react';
var RETAIN_SDK_JS = "(function(i,s,o,g,r,a,m){i['ProfitWellObject']=r;i[r]=i[r]||function(){\n  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);\n  })(window,document,'script','https://dna8twue3dlxq.cloudfront.net/js/profitwell.js','profitwell');";
export var RetainSDK =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RetainSDK, _React$Component);

  function RetainSDK() {
    _classCallCheck(this, RetainSDK);

    return _possibleConstructorReturn(this, _getPrototypeOf(RetainSDK).apply(this, arguments));
  }

  _createClass(RetainSDK, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (nextProps.currentUser && !this.props.currentUser && this.isProfitwellLoaded()) {
        this.profitwell('user_email', nextProps.currentUser.email);
      }

      return false;
    }
  }, {
    key: "isProfitwellLoaded",
    value: function isProfitwellLoaded() {
      return !!window.profitwell;
    }
    /* istanbul ignore next */

  }, {
    key: "profitwell",
    value: function profitwell(type, data) {
      return window.profitwell(type, data);
    }
  }, {
    key: "isRetainEnabled",
    value: function isRetainEnabled() {
      return !__LOCAL_DEV__ || __TEST__;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          currentUser = _this$props.currentUser,
          accountKey = _this$props.accountKey;

      if (!this.isRetainEnabled()) {
        return false;
      }

      var userSetJs = "profitwell('auth_token', '".concat(accountKey, "');"); // Profitwell uses custom path params to allow non-logged in users to update their information
      // when coming from the Profitwell emails

      if (currentUser && currentUser.email) {
        userSetJs += "profitwell('user_email', ".concat(JSON.stringify(currentUser.email), ");");
      }

      return React.createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: (RETAIN_SDK_JS + userSetJs).replace(/\n/g, '')
        }
      });
    }
  }]);

  return RetainSDK;
}(React.Component);
RetainSDK.propTypes = {
  currentUser: PropTypes.object,
  accountKey: PropTypes.string.isRequired
};